import { request } from "@/service/request";
import { HttpResponse } from "@/service/common/entity/HttpResponse";
import { ewodHost } from "@/config/host";
import { ImageServer } from "../entity/ImageServer";
import { NewProductFeatureLabel } from "../entity/NewProductFeatureLabel";
import { KeyValue } from "../entity/KeyValue";
import { ResNewProductClothingAndElectronicInfoDTO } from "../entity/ResNewProductClothingAndElectronicInfoDTO";
import { ResCommonMapDTO } from "../entity/ResCommonMapDTO";
import { ResNewProductOldCategoryDTO } from "../entity/ResNewProductOldCategoryDTO";
/**
 * 获取图片服务器信息
 * @returns
 */
export function getImagesServer(): Promise<HttpResponse<ImageServer>> {
  return request({
    url: `${ewodHost}/newProduct/getImagesServer`,
    method: "get",
    withCredentials: true,
  });
}

/**
 * 智能识别
 * @returns
 */
export function propertyParamTextAnalyze(str: string): Promise<
  HttpResponse<
    [
      {
        [x: string]: string;
      }
    ]
  >
> {
  return request({
    url: `${ewodHost}/newProduct/propertyParamTextAnalyze`,
    method: "post",
    data: str,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

/**
 * 添加新品
 * @param data
 * @returns
 */
export function addNewProduct<T>(data: T): Promise<HttpResponse<void>> {
  return request({
    url: `${ewodHost}/newProduct/addNewProduct`,
    method: "post",
    data,
    withCredentials: true,
  });
}

/**
 * 获取新品特性标注
 */
export function getNewProductFeatureLabels(): Promise<
  HttpResponse<NewProductFeatureLabel[]>
> {
  return request({
    url: `${ewodHost}/newProduct/getNewProductFeatureLabels`,
    method: "get",
    withCredentials: true,
  });
}

/**
 * 获取四季标签
 * @returns
 */
export function getSeasonLabel(): Promise<HttpResponse<KeyValue[]>> {
  return request({
    url: `${ewodHost}/newProduct/getSeasonLabel`,
    method: "get",
    withCredentials: true,
  });
}

/**
 * 获取产品类型
 * @returns
 */
export function getNewProductType(): Promise<HttpResponse<KeyValue[]>> {
  return request({
    url: `${ewodHost}/newProduct/getNewProductType`,
    method: "get",
    withCredentials: true,
  });
}

/**
 * 获取产品类型对应属性类型
 * @returns
 */
export function getNewProductTypeLabels(params: {
  id: number;
}): Promise<HttpResponse<ResNewProductClothingAndElectronicInfoDTO>> {
  return request({
    url: `${ewodHost}/newProduct/getNewProductTypeLabels`,
    method: "get",
    params,
    withCredentials: true,
  });
}

/**
 * 获取二级服装品类
 * @param params
 * @param params.key <string> 一级品类key
 * @returns
 */
export function getSecondClothingCategory(params: {
  key: string;
}): Promise<HttpResponse<ResCommonMapDTO[]>> {
  return request({
    url: `${ewodHost}/newProduct/getSecondClothingCategory`,
    method: "get",
    params,
    withCredentials: true,
  });
}

/**
 * 获得旧产品分类
 * @param params
 * @returns
 */
export function getNewProductOldCategory(params: {
  id: string;
}): Promise<HttpResponse<ResNewProductOldCategoryDTO>> {
  return request({
    url: `${ewodHost}/newProduct/getNewProductOldCategory`,
    method: "get",
    params,
    withCredentials: true,
  });
}

/**
 * 获得旧产品分类
 * @param params
 * @returns
 */
export function getProductCategoryParamFileds(params: {
  cateId: string;
}): Promise<
  HttpResponse<
    {
      cate_id: string;
      param_id: number;
      param_name: string;
      required: boolean;
    }[]
  >
> {
  return request({
    url: `${ewodHost}/newProduct/getProductCategoryParamFileds`,
    method: "get",
    params,
    withCredentials: true,
  });
}
